import styled from 'styled-components';
import { lighten } from 'polished';

export const Container = styled.nav`
  .item-paginate {
    padding: 5px 12px;
    font-weight: 600;
    font-size: 0.9rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${({ theme }) => theme.colors.secondary};

    & + .item-paginate {
      margin-left: 3px;
    }

    a {
      color: ${({ theme }) => theme.colors.secondary};
    }

    &:hover {
      background: ${({ theme }) => lighten(0.5, theme.colors.primary)};
    }
  }

  .item-paginate-active {
    background: ${({ theme }) => theme.colors.secondary};

    a {
      color: ${({ theme }) => theme.colors.primary};
    }

    &:hover {
      background: ${({ theme }) => theme.colors.primary};
    }
  }

  .item-paginate-disabled {
    opacity: 0.5;
    cursor: not-allowed;

    a {
      cursor: not-allowed;
    }
  }
`;
